import api from './api';

const adminService = {
  // Existing methods
  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },

  getUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },

  getUser: async (id) => {
    const response = await api.get(`/admin/users/${id}`);
    return response.data;
  },

  createUser: async (userData) => {
    const response = await api.post('/admin/users', userData);
    return response.data;
  },

  updateUser: async (id, userData) => {
    const response = await api.put(`/admin/users/${id}`, userData);
    return response.data;
  },

  deleteUser: async (id) => {
    const response = await api.delete(`/admin/users/${id}`);
    return response.data;
  },

  getAllShifts: async () => {
    const response = await api.get('/admin/shifts');
    return response.data;
  },

  // Audit Logs
  getAuditLogs: async (params = {}) => {
    const response = await api.get('/admin/audit-logs', { params });
    return response.data;
  },

  getAuditLogActions: async () => {
    const response = await api.get('/admin/audit-logs/actions');
    return response.data;
  },

  deleteAuditLogs: async (ids) => {
    const response = await api.delete('/admin/audit-logs', { data: { ids } });
    return response.data;
  },

  exportAuditLogs: async (format = 'xlsx', params = {}) => {
    const response = await api.get('/admin/audit-logs/export', {
      params: { format, ...params },
      responseType: 'blob'
    });
    return response;
  },

  // Admin Files
  getAdminFiles: async (params = {}) => {
    const response = await api.get('/admin/files', { params });
    return response.data;
  },

  downloadAdminFile: async (id) => {
    const response = await api.get(`/admin/files/${id}/download`, {
      responseType: 'blob'
    });
    return response;
  },

  deleteAdminFile: async (id) => {
    const response = await api.delete(`/admin/files/${id}`);
    return response.data;
  },

  // Settings
  getSettings: async () => {
    const response = await api.get('/admin/settings');
    return response.data;
  },

  updateSettings: async (settings) => {
    const response = await api.put('/admin/settings', settings);
    return response.data;
  }
};

export default adminService;
